import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import FormContainer from 'components/FormContainer';
import ShowInformation from 'components/ShowInformation';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const MetaInformation = ({
  created,
  origin,
  confirmationNumber,
  channel,
  campaignTag,
  otaBookingNumber
}) => {

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">META INFORMATION</div>
      </CardHeader>
      <FormContainer>
        <ShowInformation title="CREATED" description={moment(created).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')} />
        <ShowInformation title="ORIGIN" description={origin} />
        <ShowInformation title="CONFIRMATION #" description={confirmationNumber} />
        <ShowInformation title="CHANNEL" description={channel} />
        <ShowInformation title="OTA BOOKING #" description={otaBookingNumber} />
        <ShowInformation title="CAMPAIGN TAG" description={campaignTag} />
      </FormContainer>
    </Card>
  )
}

export default MetaInformation;
